<div class="container">
	<mos-offer-product [offer]="offer()"></mos-offer-product>
	<div
		class="quantity-container"
		[class.offset]="!!offer().discount"
		[class.pack]="offer().type === BankOfferTypes.PACK || isEventType(offer().type)"
	>
		@if (offer().type === BankOfferTypes.PACK || isEventType(offer().type)) {
			@if (offer().tickets > 0) {
				<div class="pack-product">
					<div class="pack-product-type tickets">
						<mos-currency-icon currency="ticket"></mos-currency-icon>
					</div>
					<div class="quantity">x{{ offer().tickets | number }}</div>
				</div>
			}
			@if (offer().keys > 0) {
				<div class="pack-product">
					<div class="pack-product-type keys">
						<mos-currency-icon currency="key"></mos-currency-icon>
					</div>
					<div class="quantity">x{{ offer().keys | number }}</div>
				</div>
			}
		}

		@if (offer().type === BankOfferTypes.TICKETS || offer().type === BankOfferTypes.CHAPTER_PASS) {
			@if (offer().ticketsPreDiscount > 0) {
				<div class="pre-discount">
					<div class="quantity-pre-discount">{{ offer().ticketsPreDiscount | number }}</div>
					<div class="strike-through"></div>
				</div>
			}
			<div class="quantity">{{ offer().tickets | number }}</div>
		} @else if (offer().type === BankOfferTypes.KEYS) {
			@if (offer().keysPreDiscount > 0) {
				<div class="pre-discount">
					<div class="quantity-pre-discount">{{ offer().keysPreDiscount | number }}</div>
					<div class="strike-through"></div>
				</div>
			}
			<div class="quantity">{{ offer().keys | number }}</div>
		}

		@if (limitedOffer()) {
			<div class="discount" [class.limited]="limitedOffer()">
				<div class="discount-label" i18n="@@shop.offer.limited-badge">Offre limitée</div>
			</div>
		} @else if (offer().discount > 0) {
			<div class="discount">
				<div class="discount-label">-{{ offer().discount }} %</div>
			</div>
		}
	</div>
	<div class="price-container" [class.free]="offer().currency === BankOfferExtraCurrencyTypes.FREE_ONCE">
		@if (['keys', 'tickets'].includes(offer().currency)) {
			<div class="currency" [class]="offer().currency"></div>
			<div class="price">{{ offer().price | number }}</div>
		} @else if (offer().currency === BankOfferExtraCurrencyTypes.ADVERTISEMENT) {
			<mos-icon [icon]="icons.video" />
		} @else if (offer().currency === BankOfferExtraCurrencyTypes.FREE_ONCE) {
			<div class="price" i18n="@@shop.offer.free-badge">GRATUIT</div>
		} @else {
			<div class="price">{{ offer().price | currency: offer().currency }}</div>
		}
	</div>

	@if (offer().isPopular) {
		<div class="banner">
			<div class="banner-content" i18n="@@shop.offer.popular-badge">Populaire</div>
		</div>
	} @else if (offer().isBest) {
		<div class="banner">
			<div class="banner-content" i18n="@@shop.offer.best-badge">Meilleure offre</div>
		</div>
	}

	@if (pending()) {
		<div class="pending-overlay">
			<div class="pending-loader"></div>
		</div>
	}
</div>

@if (remainingTimeLabel()) {
	<!-- Its own animate.leave (in addition to the host-reactive rule for the whole card leaving) - this
	     can toggle off on its own, while the rest of the card stays mounted, once the countdown reaches
	     zero. Angular only invokes one animate.leave binding per removal (the outermost), so without
	     this the host's own binding would win when the whole card leaves and this one would never fire
	     when only the timer itself needs to disappear (see docs/animations-migration.md). -->
	<div class="remaining-time" animate.leave="remaining-time-out">
		<div class="remaining-time-label">
			{{ remainingTimeLabel() }}
			<div class="remaining-time-icon"></div>
		</div>
	</div>
}

@if (offer().pricePreDiscount !== null) {
	<div class="price-pre-discount" i18n="@@shop.offer.price-before-discount">
		au lieu de {{ offer().pricePreDiscount | currency: offer().currency }}
	</div>
}

@if (disabled() && offer().currency === BankOfferExtraCurrencyTypes.ADVERTISEMENT && !maxVideoRewardedReached()) {
	<div class="video-issue">
		<div i18n="@@shop.offer.ad-unavailable" class="error">
			Pas de publicité disponible, vérifie ton bloqueur de publicité et/ou réessaye dans quelques minutes
		</div>
	</div>
}
